function searchMenuMobile() {
// on mobile, open/close the search block outputted in header.html.twig
  jQuery('.mobile-search').on('click', function(e) {
    // stop, collaborate, and listen
    e.preventDefault();
    // the search icon that shows on mobile
    jQuery('.mobile-search').toggleClass('open');
    // the html outputted via .theme file and header.html.twig
    jQuery('.search-menu-mobile').toggleClass('open');
  });
};

export { searchMenuMobile }


